import classNames from 'classnames';
import { Footer, Navigation } from '@libs/components';
import { Button } from 'primereact/button';
import { useAuthorize } from '@libs/utils';
import { useEffect } from 'react';

import styles from './styles.module.scss';

export const SessionEmailExpiredPage = () => {
    const { loginHandler } = useAuthorize();

    useEffect(() => {
        document.title = 'Сеанс работы завершен';
    }, []);

    return (
        <>
            <div className="main-wrapper">
                <div>
                    <Navigation />
                    <div className={classNames('flex', 'flex-column', styles.sessionEmailExpiredPageWrapper)}>
                        <div className={styles.pageContent}>
                            <div className={styles.textBlock}>
                                <h1>ваша сессия была завершена</h1>
                                <span>
                                    Вас долго не было и мы завершили Вашу сессию в Datashop. Чтобы подтвердить email,
                                    нужно войти в личный кабинет заново.
                                </span>
                            </div>
                            <Button label={'Войти и подтвердить'} onClick={() => loginHandler()} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
